import React, { useEffect } from 'react';
import imgPrueba from '../../assets/img-prueba.jpg';
import ItemCard from '../../components/ItemCard/ItemCard';
import { useStore } from '../../store/Store';
import { fetchData } from '../../store/ActionProgramas';
import { areas } from '../../utils/constantes';
import { slugify } from '../../utils/utils';
import './Area.css';
import PageLoading from '../../components/PageLoading';
import PageError from '../../components/PageError';

function Area({
  match: {
    params: { area: areaSlug }
  }
}) {
  const {
    state: { programas, loading },
    dispatch
  } = useStore();

  useEffect(() => {
    programas.length === 0 && fetchData(dispatch);
  }, []);

  const fillContent = () => {
    if (loading) return <PageLoading />;
    if (!programas)
      return <PageError error="No se pudieron obtener los programas." />;

    const area = areas.filter(area => area.slug === areaSlug)[0];

    if (!area) return 'No existe';

    let key = 1;
    return (
      <section id="programas">
        <h2>{area.nombre}</h2>
        <div className="contenedor-listado">
          {programas.map(
            programa =>
              programa.area === area.id && (
                <ItemCard
                  key={key++}
                  programa={programa}
                  area={area}
                  img={imgPrueba}
                  style="margin"
                />
              )
          )}
        </div>
      </section>
    );
  };

  return fillContent();
}

export default Area;
